module.exports = __webpack_public_path__ + "img/logo.d4c5025d.png";